import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import * as Highcharts from 'highcharts';
import * as _ from 'lodash';
import { CHART_COLORS, CHART_CONFIG_DAY, CHART_CONFIG_HOUR, timeStringToTimestamp } from './area-chart.config';

@Component({
  selector: 'app-area-chart',
  templateUrl: './area-chart.component.html',
  styleUrls: ['./area-chart.component.scss']
})
export class AreaChartComponent implements OnInit, OnChanges {
  @Input() public loading: boolean;
  @Input() public data: any[];
  @Input() public versions: string[];
  @Input() public country: string;
  @Input() public dimension: string;
  @Input() public dimensionLabel: string;
  Highcharts: typeof Highcharts = Highcharts;
  public chartOptions: Highcharts.Options;

  constructor() {
    this.loading = true;
    this.data = [];
    this.versions = [];
    this.country = '';
    this.dimension = '';
    this.dimensionLabel = '';
  }

  ngOnInit() {
    this.initChart();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.country || changes.data || changes.dimension
      || !_.isEqual(changes.versions.previousValue, changes.versions.currentValue)) {
      this.initChart();
    }
  }

  getDataForVersion(version: string) {
    const data = this.data.filter(item => item.co === this.country && item.s4.replace(/\\\//g, "/") === version).map((item) => {
      return {
        x: this.getX(item),
        y: Number(item[this.dimension]),
      };
    });

    return _.sortBy(data, (o) => o.x);
  }

  initChart() {
    const series = this.versions.map((version, index) => {
      return {
        type: 'area',
        name: version,
        data: this.getDataForVersion(version),
        color: CHART_COLORS[index],
      };
    }) as any[];

    const isHourlyChart = this.data.some(item => item.hr);
    this.chartOptions = {
      ...(isHourlyChart ? CHART_CONFIG_HOUR : CHART_CONFIG_DAY),
      series,
      yAxis: {
        title: {
          text: this.dimensionLabel,
        },
      },
    };
  }

  getX(item) {
    return item.hr ? timeStringToTimestamp(`${item.hr}:00`) : new Date(item.dy).getTime();
  }

}
